export * from './home.component';
export * from './home-consultas';
export * from './home-dashboard';
export * from './home-destaques';